import type {PerseusDropdownWidgetOptions} from "../../data-schema";

/**
 * For details on the individual options, see the
 * PerseusDropdownWidgetOptions type
 */
export type DropdownPublicWidgetOptions = {
    choices: ReadonlyArray<{content: string}>;
    placeholder: PerseusDropdownWidgetOptions["placeholder"];
    visibleLabel?: PerseusDropdownWidgetOptions["visibleLabel"];
    ariaLabel?: PerseusDropdownWidgetOptions["ariaLabel"];
};

/**
 * Given a PerseusDropdownWidgetOptions object, return a new object with only
 * the public options that should be exposed to the client.
 */
export function getDropdownPublicWidgetOptions(
    options: PerseusDropdownWidgetOptions,
): DropdownPublicWidgetOptions {
    return {
        choices: options.choices.map((choice) => ({content: choice.content})),
        placeholder: options.placeholder,
        visibleLabel: options.visibleLabel,
        ariaLabel: options.ariaLabel,
    };
}
